import React from "react";
import Seo from "../components/Seo";
import "../styles/pages/service-detail.css";

function Training() {
    return (
        <main className="page">
            <Seo
                title="Mental Health Staff Training"
                path="/services/training"
                description="Specialist mental health staff training focused on awareness, communication, de-escalation, person-centred support planning, and safer practice."
                keywords="mental health staff training, de-escalation training, health care staff training, person centred support"
            />

            <div className="container service-detail">
                <div className="service-hero-card">
                    <p className="eyebrow">Mental Health Training</p>
                    <h1>Skills-focused training that builds confidence and safer practice</h1>
                    <p>
                        Our training services are built to improve understanding, confidence, and day-to-day practice when supporting individuals with mental health needs.
                    </p>
                </div>
                <div className="info-card">
                    <h2>Training Focus Areas</h2>
                    <ul className="detail-list">
                        <li>Mental health awareness and understanding</li>
                        <li>Communication and de-escalation skills</li>
                        <li>Person-centered support planning</li>
                        <li>Risk awareness and safer practice</li>
                    </ul>
                </div>
            </div>
        </main>
    );
}

export default Training;